export var isGiftCardInFulfillmentGroup = function (fulfillmentGroup) {
    var _a;
    if (fulfillmentGroup === undefined)
        return false;
    return (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _a === void 0 ? void 0 : _a.some(function (lineItem) { return lineItem === null || lineItem === void 0 ? void 0 : lineItem.isGiftCard; });
};
var regex = /^[a-zA-Z0-9/., -]+$/;
export var renderStatusMessage = function (type, value) {
    var renderMessage;
    if (type === 'first') {
        if (value === '') {
            renderMessage = 'Please provide a valid first name.';
        }
        else if (value.length >= 40) {
            renderMessage = "First name can't be longer than 40 characters.";
        }
        else if (!regex.test(value)) {
            renderMessage =
                'We only allow letters (a-z), numbers and the following symbols: -/.,';
        }
    }
    if (type === 'last') {
        if (value === '') {
            renderMessage = 'Please provide a valid last name.';
        }
        else if (value.length >= 60) {
            renderMessage = "Last name can't be longer than 60 characters.";
        }
        else if (!regex.test(value)) {
            renderMessage =
                'We only allow letters (a-z), numbers and the following symbols: -/.,';
        }
    }
    return renderMessage;
};
export var nameRegex = /^[a-zA-Z0-9/., -]+$/;
export var zipRegex = /^[0-9]+$/; // Regular expression to allow only digits (0-9) for ZIP Code
export var addressRegex = /^[a-zA-Z0-9\s,.'-]{1,30}$/; // Allow alphanumeric characters, spaces, commas, periods, and hyphens
